import { Action } from '@zaibot/fsa';

export type SortingMethod = 'createdAsc'|'createdDesc'|'pageNumber';
export default Action<{ sorting: SortingMethod }>('PAGEFILTER_TOGGLE_SORTING');



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/pageFilter/actions/PAGEFILTER_TOGGLE_SORTING.tsx